import { ExpandableRowDef } from '@/components';
import { ColumnDef } from '@/components/Table/types';
import { useState } from 'react';
import { ExpandableTableRowCell } from '..';

type ExpandableTableRowProps<T> = {
  row: ExpandableRowDef<T>;
  columns: ColumnDef<T>[];
  depth?: number;
  className?: string;
};

export const ExpandableTableRow = <T,>({
  row,
  columns,
  depth = 0,
  className,
}: ExpandableTableRowProps<T>) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <ExpandableTableRowCell
        row={row}
        columns={columns}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        depth={depth}
        className={className}
      />
      {isOpen &&
        row?.rows?.map((child) => (
          <ExpandableTableRow
            key={child.id}
            row={child}
            columns={columns}
            depth={depth + 1}
          />
        ))}
    </>
  );
};
